export const getHomeAppURL = () => (window.AFP_CONFIG && window.AFP_CONFIG.appURLs) ? 
            window.AFP_CONFIG.appURLs.home : 
            undefined;
